module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNTc2Ij48cGF0aCBkPSJNMCAwaDgwMHY1NzZIMCIgZmlsbD0iIzAyNTI5QyIvPjxwYXRoIGQ9Ik0yMjQgMGgxMjh2NTc2SDIyNE0wIDIyNGg4MDB2MTI4SDAiIGZpbGw9IiNGRkYiLz48cGF0aCBkPSJNMjU2IDBoNjR2NTc2aC02NE0wIDI1Nmg4MDB2NjRIMCIgZmlsbD0iI0RDMUUzNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/isl.svg
// module id = kmh3
// module chunks = 0